/**
 * MEDWORK.iO logo — dark gray "MEDWORK" text with blue ".iO" speech bubble accent.
 */
export function MedworkLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="MEDWORK.iO"
    >
      {/* MEDWORK text */}
      <text
        x="0"
        y="28"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="700"
        fontSize="30"
        letterSpacing="-0.5"
        fill="#3D4550"
      >
        MEDWORK
      </text>
      {/* Blue speech bubble with .iO */}
      <circle cx="178" cy="15" r="16" fill="#4A9EF5" />
      {/* Bubble tail */}
      <path d="M166 24 L170 30 L174 24" fill="#4A9EF5" />
      <text
        x="178"
        y="20"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="600"
        fontSize="14"
        fill="white"
        textAnchor="middle"
      >
        .iO
      </text>
    </svg>
  );
}
